// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { isSendingDomain } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

export const ispostSendingDomainResult = objectOf({
  sendingDomain: isSendingDomain,
});
